import React, { Fragment } from "react"

import CoTable from "../../../../Containers/Table"

import { convertToMonthName } from "../../../../../Global"

const PRTracker = ({ isLoading, Data }) => {

    const st_TableHead = { color: 'white', backgroundColor: '#00a3df' }
    const st_TableBorderHead = { borderTop: '1px solid black', borderRight: '0px solid black', borderBottom: '1px solid black', borderLeft: '1px solid black', fontFamily: 'Montserrat, Segoe UI', fontSize: '1.2vw' }
    const st_TableBorder = { borderLeft: '1px solid black', fontFamily: 'Montserrat, Segoe UI', fontSize: '1.2vw' }

    const HeadData = [
        {
            Nama: 'No',
            width: '5%',
            KeyName: 'index',
            SortingType: 'Number',
            style: { ...st_TableHead, ...st_TableBorderHead },
            BodyStyle: { ...st_TableBorder }
        },
        {
            Nama: 'Submission Number',
            width: '5%',
            KeyName: 'SubmissionNumber',
            SortingType: 'Number',
            style: { ...st_TableHead, ...st_TableBorderHead },
            BodyStyle: { ...st_TableBorder }
        },
        {
            Nama: 'Submission Date',
            width: '5%',
            KeyName: 'TanggalPengajuan',
            SortingType: 'Date',
            style: { ...st_TableHead, ...st_TableBorderHead },
            BodyStyle: { ...st_TableBorder }
        },
        {
            Nama: 'Division',
            width: '5%',
            KeyName: 'DivisionNama',
            style: { ...st_TableHead, ...st_TableBorderHead },
            BodyStyle: { ...st_TableBorder }
        },
        {
            Nama: 'Department',
            width: '5%',
            KeyName: 'DepartemenNama',
            style: { ...st_TableHead, ...st_TableBorderHead },
            BodyStyle: { ...st_TableBorder }
        },
        {
            Nama: 'Job Title',
            width: '25%',
            KeyName: 'Sub',
            style: { ...st_TableHead, ...st_TableBorderHead },
            BodyStyle: { ...st_TableBorder }
        },
        {
            Nama: 'Level',
            width: '5%',
            KeyName: 'LevelNama',
            style: { ...st_TableHead, ...st_TableBorderHead },
            BodyStyle: { ...st_TableBorder }
        },
        {
            Nama: 'Contract Type',
            width: '5%',
            KeyName: 'StatusKaryawan',
            style: { ...st_TableHead, ...st_TableBorderHead },
            BodyStyle: { ...st_TableBorder }
        },
        {
            Nama: 'Year',
            width: '5%',
            KeyName: 'Tahun',
            style: { ...st_TableHead, ...st_TableBorderHead },
            BodyStyle: { ...st_TableBorder }
        },
        {
            Nama: 'Month',
            width: '5%',
            KeyName: 'BulanBuka',
            style: { ...st_TableHead, ...st_TableBorderHead },
            BodyStyle: { ...st_TableBorder }
        },
        {
            Nama: 'Periode',
            width: '5%',
            KeyName: 'Periode',
            style: { ...st_TableHead, ...st_TableBorderHead },
            BodyStyle: { ...st_TableBorder }
        },
        {
            Nama: 'PR Type',
            width: '5%',
            KeyName: 'PRType',
            style: { ...st_TableHead, ...st_TableBorderHead },
            BodyStyle: { ...st_TableBorder }
        },
        {
            Nama: 'Status',
            width: '5%',
            KeyName: 'Status',
            style: { ...st_TableHead, ...st_TableBorderHead },
            BodyStyle: { ...st_TableBorder }
        },
        {
            Nama: 'Item',
            width: '5%',
            KeyName: 'ItemListWithCount',
            style: { ...st_TableHead, ...st_TableBorderHead, ...{ borderRight: '1px solid black' } },
            BodyStyle: { ...st_TableBorder, ...{ borderRight: '1px solid black' } }
        },
    ]

    const BodyData = Data ? Data.map((item, index) => {
        return {
            index: {
                value: index + 1
            },
            SubmissionNumber: {
                value: item?.Id ? item.Id : ' '
            },
            TanggalPengajuan: {
                display: item?.TanggalPengajuan ? new Date(item.TanggalPengajuan).toLocaleString(['ban', 'id']) : ' ',
                value: item?.TanggalPengajuan ? item.TanggalPengajuan : ' '
            },
            DivisionNama: {
                value: item?.DivisionNama ? item.DivisionNama : ' '
            },
            DepartemenNama: {
                value: item?.DepartemenNama ? item.DepartemenNama : ' '
            },
            Sub: {
                value: item?.NamaPosisi ? item.NamaPosisi : ' '
            },
            LevelNama: {
                value: item?.LevelNama ? item.LevelNama : ' '
            },
            StatusKaryawan: {
                value: item?.TipePegawai ? item.TipePegawai : ' '
            },
            Tahun: {
                value: item?.Tahun ? item.Tahun : ' '
            },
            BulanBuka: {
                value: convertToMonthName(item.BulanBuka)
            },
            Periode: {
                value: item?.ContractDuration ? item.ContractDuration : ' '
            },
            PRType: {
                value: item ? item.isBaruOrMenggantikan === true ? 'New' : item.isBaruOrMenggantikan === false ? 'Replacement' : ' ' : ' '
            },
            Status: {
                display: (
                    <span
                        style={{
                            color: item?.Status ? item.Status === 'Accept' ? 'green'
                                : item.Status === 'Reject' ? 'red'
                                    : 'orange'
                                : 'black'
                        }}
                    >
                        {item?.Status ? item.Status : ' '}
                    </span>
                ),
                value: item?.Status ? item.Status : ' '
            },
            ItemListWithCount: {
                value: item?.ItemListWithCount ? item.ItemListWithCount : ' '
            },
        }
    }) : []

    return (
        <Fragment>
            <CoTable
                TableId={'PRTracker'}
                HeadData={HeadData}
                Data={BodyData}
                isHeadLoading={isLoading}
                isBodyLoading={isLoading}
                isPagination={BodyData.length > 5 ? true : false}
                isPaginationLoading={isLoading}
                isHeading={true}
                isDownload={true}
                ComplexDataDownload={true}
            />
        </Fragment>
    )
}

export default PRTracker